export default "__VITE_ASSET___915ZJjw__"